import React, { useState } from 'react'
import {
  FaBuilding,
  FaBullseye,
  FaGlobe,
  FaCity,
  FaPhone,
  FaCheckCircle,
  FaTimes,
  FaBars,
  FaInfoCircle,
  FaBoxOpen,
} from 'react-icons/fa'
import ZynthLogoText from '../../assets/logo-08 (1).png'
import { Section } from '../../types/onboardingTypes'
import { Theme } from '../../lib/theme.ts';
import { FaGift } from 'react-icons/fa'

const sections: Section[] = [
  {
    id: 1,
    title: 'Organization Name',
    subheading: 'Provide Organization details',
    icon: <FaBuilding />,
  },
  {
    id: 2,
    title: 'Branding',
    subheading: 'Upload your logo',
    icon: <FaBullseye />,
  },
  {
    id: 3,
    title: 'Website Link',
    subheading: 'Provide your website link',
    icon: <FaGlobe />,
  },
  // {
  //   id: 4,
  //   title: 'Industry',
  //   subheading: 'Provide industry Details',
  //   icon: <FaCity />,
  // },

{
    id: 4,
    title: 'About the Company',
    subheading: 'Provide Brief description of the startup/idea.',
    icon: <FaInfoCircle />,
  },
  
    {
    id: 5,
    title: 'Products and Services',
    subheading: 'Provide Brief description of the products and services you offer.',
    icon: <FaBoxOpen />,
  },
  {
  id: 6,
  title: 'Referral Code',
  subheading: 'Enter your referral code',
  icon: <FaGift />, // ✅ Fixed
  },

  {
    id: 7,
    title: 'Contact Details',
    subheading: 'Provide contact details',
    icon: <FaPhone />,
  },
  
 
  
  
]

interface SidebarProps {
  lastVisitedSection: number
  visitedSections: number[]
}

const Sidebar: React.FC<SidebarProps> = ({
  lastVisitedSection,
  visitedSections,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

return (
  <>
    {/* Mobile toggle button */}
    <div className="lg:hidden p-4">
      <FaBars
        className="text-2xl cursor-pointer"
        style={{ color: Theme.colors.text.default }}
        onClick={toggleSidebar}
      />
    </div>

    {/* Sidebar container */}
    <div
      className={`fixed lg:relative lg:w-64 h-screen transition-transform transform ${
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}
      style={{ backgroundColor: Theme.colors.stroke.weak }}
    >
      {/* Close button (mobile only) */}
      {isSidebarOpen && (
        <FaTimes
          className="absolute top-4 right-4 text-2xl cursor-pointer"
          style={{ color: Theme.colors.text.default }}
          onClick={toggleSidebar}
        />
      )}

      {/* Logo */}
      <div className="flex items-center justify-center mb-8 mt-8 mr-2 gap-1">
        <a
          href="/"
          target="_blank"
          rel="noopener noreferrer"
          className="transition-all duration-300 transform"
        >
          <img
            className="h-8 hover:scale-110 active:scale-95 active:opacity-80 transition-all transform"
            src={ZynthLogoText}
            alt="Zynth"
          />
        </a>
      </div>

      {/* Sections */}
      <div className="relative">
        {sections.map((section, index) => {
          const isActive = section.id === lastVisitedSection
          const isVisited = visitedSections.includes(section.id)

          return (
            <div
              key={section.id}
              className="relative w-full"
              style={{
                backgroundColor: isActive
                  ? Theme.colors.background
                  : 'transparent',
              }}
            >
              <div
                className={`flex items-center py-1 mb-3 lg:mb-4 xl:mb-6 space-x-4 pl-4 transition-colors duration-300 h-full ${
                  isActive
                    ? 'border-l-4'
                    : 'border-l-4 border-transparent'
                }`}
                style={{
                  borderColor: isActive
                    ? Theme.colors.primary
                    : 'transparent',
                }}
              >
                {/* Icon & Dotted Line */}
                <div className="flex flex-col items-center">
                  <div
                    className="text-2xl"
                    style={{
                      color:
                        isActive || isVisited
                          ? Theme.colors.primary
                          : Theme.colors.text.weak,
                    }}
                  >
                    {isVisited && !isActive ? (
                      <FaCheckCircle />
                    ) : (
                      section.icon
                    )}
                  </div>

                  {/* Vertical Progress Bar */}
                  {index < sections.length - 1 &&
                    visitedSections.includes(sections[index + 1].id) && (
                      <div
                        className="w-1 h-2 border-l-2 border-dotted mt-2"
                        style={{ borderColor: Theme.colors.stroke.weak }}
                      ></div>
                    )}
                </div>

                {/* Text */}
                <div>
                  <h2
                    className="font-semibold text-lg"
                    style={{
                      color:
                        isActive || isVisited
                          ? Theme.colors.primary
                          : Theme.colors.text.default,
                    }}
                  >
                    {section.title}
                  </h2>
                  <p
                    className="text-sm"
                    style={{ color: Theme.colors.text.weak }}
                  >
                    {section.subheading}
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  </>
)

}

export default Sidebar
